import { AnyAction } from 'redux'
import { CONTENT_UPDATE, SIMILAR_TEMPLATES_INJECT, SIMILAR_TEMPLATES_RESET } from 'client/store/constants'
import { createSelector } from 'reselect'
import { QUICK_VIEW_ID_RESET } from 'client/store/debug/actions'

const initialState: State.TileEntityState = {
  byId: {},
  allIds: [],
}

const updateState = (action: AnyAction, state: State.TileEntityState = initialState): State.TileEntityState => ({
  ...state,
  byId: action.payload.tileEntities.byId,
  allIds: action.payload.tileEntities.allIds,
})

export function reducer(state: State.TileEntityState = initialState, action: AnyAction): State.TileEntityState {
  switch (action.type) {
    case CONTENT_UPDATE:
      return updateState(action, state)
    case SIMILAR_TEMPLATES_INJECT:
      return {
        ...state,
        byIdSimilarTemplates: {
          ...state.byIdSimilarTemplates,
          ...action.payload.tileEntities.byId,
        },
      }
    case SIMILAR_TEMPLATES_RESET:
      delete state.byIdSimilarTemplates
      return state
    case QUICK_VIEW_ID_RESET: {
      const { designId } = action.payload

      if (!designId) {
        return state
      }

      const qvTileEntity = state.byId[designId]

      if (!qvTileEntity) {
        return state
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [designId]: {
            ...qvTileEntity,
            isQSPEntity: false,
          },
        },
      }
    }
    default:
      return state
  }
}

export const tileEntityAllIdsSelector = (state: State.GlobalState): string[] => state.tileEntities.allIds

export const tileEntityByIdSelector = createSelector(
  (state: State.GlobalState) => state.tileEntities,
  (tileEntities) =>
    (id: string): State.TileEntity =>
      ({ ...tileEntities.byId, ...tileEntities.byIdSimilarTemplates })[id],
)
